import { parseChordSymbol, rootToPc } from './chordParse';

const QUALITY_INTERVALS = {
  maj: [0, 4, 7],
  '5': [0, 7],
  maj7: [0, 4, 7, 11],
  m: [0, 3, 7],
  m7: [0, 3, 7, 10],
  mmaj7: [0, 3, 7, 11],
  '7sus4': [0, 5, 7, 10],
  '7sus2': [0, 2, 7, 10],
  m7b5: [0, 3, 6, 10],
  dim: [0, 3, 6],
  dim7: [0, 3, 6, 9],
  aug: [0, 4, 8],
  aug7: [0, 4, 8, 10],
  '7': [0, 4, 7, 10],
  sus2: [0, 2, 7],
  sus4: [0, 5, 7],
};

const TENSION_INTERVALS = {
  b5: 6,
  '#5': 8,
  b9: 13,
  '#9': 15,
  9: 14,
  11: 17,
  '#11': 18,
  13: 21,
  b13: 20,
  6: 9,
};

const BASE_MIDI = 60; // C4

const midiFromPitchClass = (pc) => {
  if (pc === null || pc === undefined) return null;
  return BASE_MIDI + ((pc + 12) % 12);
};

const ensureUniqueSorted = (numbers) =>
  Array.from(new Set(numbers)).sort((a, b) => a - b);

export function getMidiNotesForChord(symbol) {
  const parsed = parseChordSymbol(symbol);
  if (!parsed) return [];

  const { root, quality, tensions = [], bass } = parsed;
  const rootPc = rootToPc(root);
  if (rootPc === null || rootPc === undefined) return [];

  const rootMidi = midiFromPitchClass(rootPc);
  if (rootMidi === null) return [];

  const intervals = QUALITY_INTERVALS[quality];
  if (!intervals) return [];
  const fifth = tensions.includes('b5') ? 6 : tensions.includes('#5') ? 8 : null;
  const adjustedIntervals = fifth === null ? intervals : intervals.map((semi) => semi === 7 ? fifth : semi);
  const notes = adjustedIntervals.map((semi) => rootMidi + semi);

  const effectiveTensions = [...tensions];
  if ((tensions.includes('13') || tensions.includes('b13')) && !tensions.includes('9')) {
    effectiveTensions.push('9');
  }

  effectiveTensions.forEach((t) => {
    const semi = TENSION_INTERVALS[t];
    if (typeof semi === 'number' && t !== 'b5' && t !== '#5') {
      notes.push(rootMidi + semi);
    }
  });

  if (bass) {
    const bassPc = rootToPc(bass);
    const bassMidi = midiFromPitchClass(bassPc);
    if (bassMidi !== null) {
      notes.push(bassMidi - 12);
    }
  }

  return ensureUniqueSorted(notes);
}

export function midiToFrequency(midi) {
  return 440 * Math.pow(2, (midi - 69) / 12);
}

export function getFrequenciesForChord(symbol) {
  const midiNotes = getMidiNotesForChord(symbol);
  return midiNotes.map((midi) => midiToFrequency(midi));
}
